import { Component, OnInit, Input, NgZone, OnChanges, OnDestroy, Output,EventEmitter,SimpleChanges, ElementRef} from '@angular/core';
import { Router, ActivatedRoute} from '@angular/router';
import { ReportService } from '../inservice/report.service';
import { CookieService } from '../_services/cookie.service';
import { environment } from '../../environments/environment';
import { ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl, Title } from '@angular/platform-browser';

import {NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { createAuth0Client } from '@auth0/auth0-spa-js';

declare var $: any;
@Component({
  selector: 'app-headnav',
  templateUrl: './headnav.component.html',
  styleUrls: ['./headnav.component.css']
})
export class HeadnavComponent implements OnInit, OnChanges, OnDestroy {
 
	loginInfo="USER";
	rpts=[];
  expanded
	statusList=[];
  userId:number;
  infoContent:any;
  ssoclients=[];
  clients=[];
	@Input()  user:any;
	@Input()  logOutFlag:number;
  @Input()  loginFlag:number;
	@Output() info = new EventEmitter<any>();
	@Output() getLogo = new EventEmitter<boolean>();
	@ViewChild('content', { static: false }) private content;
  @ViewChild('mfa', { static: false }) private mfa;
  @ViewChild('userinfo', { static: false }) private userinfo;
  @ViewChild('disclaimer', { static: false }) private disclaimer;
	constructor( private fb: UntypedFormBuilder, private modalService: NgbModal, private router: Router, private ngZone: NgZone, private cookieService: CookieService, private reportService:ReportService,  private sanitizer: DomSanitizer, private route: ActivatedRoute
    ) {
      this.ssoclients=environment.api.microsoftsso;
      this.clients=[];
      for(let client of this.ssoclients){
        this.clients.push(client.clientid)
      }      
		if(this.cookieService.getCookie("userID")) {
			this.userId = parseInt(this.cookieService.getCookie("userID"));
			this.loginInfo = this.cookieService.getCookie("userName");
		}else{
		//	this.onLogin();	
      //this.openLogin(this.content);			
		}
	}
  sendMessage(msg : string) {
    this.reportService.send(msg);
 }
  forgotPassword(){
    let forgotEmail = $('#forgotEmail').val();
    let inputJson={"PROCEDURE":"ForgotPassword","EMAIL":forgotEmail, "USER_EMAIL": forgotEmail};
    
    this.reportService.univeralService2(JSON.stringify(inputJson))
    .subscribe(data => {
     
      if(data.RESPONSE_STATUS=='N'){
        this.throwError(data)
      }else{
        this.modalReference4.close();
        Swal.fire({
          title:"Email Sent",
          html: '<p style="font-size:16px;">'+data.MESSAGE+'</p>',//'<p style="font-size:16px; color:red">Login Failed</p>',
          //timer: 3000,
          showConfirmButton:true,
         // timerProgressBar: true,
  
        })
        this.openLogin();
      }

    })
  }
 
 
 curClient=''; 
  openLogin() {
    this.curClient = this.route.snapshot.queryParamMap.get('client');
    this.modalReference =this.modalService.open(this.content, { centered:true, backdrop:'static'});
  }
  modalReference2
  open(content) {
      this.modalReference2= this.modalService.open(content, { centered:true, backdrop:'static'})
  }
  modalReference3
  open2(content) {
    this.modalReference3= this.modalService.open(content, { centered:true, backdrop:'static'})
  }
  modalReference4;
  open3(content){
    this.modalReference4= this.modalService.open(content, { centered:true, backdrop:'static'});
  }
  modalReference5;
  open4(){
    this.modalReference5= this.modalService.open(this.mfa, { centered:true, backdrop:'static'});
  }
  disclaimerAcceptedFlag = false; // this is for display
  disclaimerAcceptedReal = false; // this is the actual value
  disclaimerModalReference;
  openDisclaimer() {
    this.disclaimerModalReference = this.modalService.open(this.disclaimer, {size: 'xl', centered: true, backdrop: 'static', scrollable: true});
  }
  updateDisclaimer() {
    let userid = parseInt(this.cookieService.getCookie("userID"))
    let inputJson={"PROCEDURE":"updaterwuser", "USER_ID":userid, "UPDATE_USER_ID":userid, "ACCEPTED_DISCLAIMER": this.disclaimerAcceptedReal? "N" : "Y"};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS == 'Y') {
        this.disclaimerAcceptedReal = !this.disclaimerAcceptedReal;
        this.disclaimerAcceptedFlag = this.disclaimerAcceptedReal;
        this.cookieService.setCookieSession("accepted_disclaimer", this.disclaimerAcceptedReal? "Y" : "N");
      }else{
        this.throwError(data)
      }
		})
  }
  year() {
		var d = new Date();
		return d.getFullYear();
	}

  passwordCheck=false;
  registrationForm
	ngOnInit(): void {
    this.registrationForm= this.fb.group({
			userPhone: ['', [Validators.pattern("^[0-9]*$"), Validators.min(1000000000),]],
      //singleID:['',[Validators.required]],
      // the regex checks for length >= 8, 1 upper, 1 lower, 1 symbol, 1 number.
      // the symbols are just every symbol i can find on my keyboard
      password:['',[Validators.required, Validators.pattern("(?=(.*[A-Z]){1,})(?=(.*[a-z]){1,})(?=(.*[`~!@#$%^&*()\\-_+=[\\]{}\\\|;:'\",<.>/?]){1,})(?=(.*[0-9]){1,}).{8,}")]],
      confirmpassword:['',[Validators.required]],
		});
    fetch('/assets/notification.html').then(res => res.text()).then(data => {
      this.infoContent = this.sanitizer.bypassSecurityTrustHtml(data);
    })
	}
  ngAfterViewInit(){
    if(!this.cookieService.getCookie("userID")) {
        if (this.route.snapshot.queryParamMap.get('code')) {//For funture no inuse
            // handling auth0 redirect back
            createAuth0Client({
                domain: environment.auth0.domain,
                clientId: environment.auth0.clientId
            }).then(async (auth0) => {
                await auth0.handleRedirectCallback();
                const accessToken = await auth0.getTokenSilently({
                    authorizationParams: { audience: environment.auth0.audience }
                });
                this.router.navigate(['/']);
                this.onLogin('JWT', accessToken);
            });
        } else if (this.route.snapshot.queryParamMap.get('samlToken')) {
            const samlToken = this.route.snapshot.queryParamMap.get('samlToken');
            const client = this.route.snapshot.queryParamMap.get('client');
            this.onLogin(client, samlToken);         
          }else {
            if(this.router.url==='/'||this.route.snapshot.queryParamMap.get('client')){
              this.openLogin();
            }else{
              this.router.navigate(['/'])
            }
         
        }
    }
    else if (this.cookieService.getCookie("accepted_disclaimer") == 'N') {
      this.disclaimerAcceptedFlag = false;
      this.disclaimerAcceptedReal = false;
      this.openDisclaimer();
    } 
  }
	ngOnChanges(changes: SimpleChanges): void {
      
		if ('logOutFlag' in changes) {
			if(this.logOutFlag){
				this.logOut();
			}
		}
    if('user' in changes) {
			if(this.user&&this.user.PROJECT_ID){
				let inputJson={"PROCEDURE":"getreportsforproject", "USER_ID":this.userId, "PROJECT_ID":this.user.PROJECT_ID};
				
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
					if(data.RESPONSE_STATUS=='N'){
            this.throwError(data);
          }else{
            this.rpts=data.RW_REPORTS;
          }
					
				})
				this.getStatus(this.userId, this.user.REPORT_ID);
			}
		}
		
	}
 
	ngOnDestroy(): void {
		//document.removeEventListener('contextmenu', this.handleContextMenu);
		//this.reportService.editNotify.unsubscribe();
  }
  toLogo(){
		//this.toLogoPanel=!this.toLogoPanel; /
		this.getLogo.emit(true); 
  }
  onLogout(){
    if(this.cookieService.getCookie("userInfo")){    
    let token = JSON.parse(this.cookieService.getCookie("userInfo")).SESSION_ID;
    let id=JSON.parse(this.cookieService.getCookie("userInfo")).USER_ID;
    let inputJson={"PROCEDURE":"rwuserlogout","USER_ID":id,"SESSION_ID":token};
    this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(result => {
      if(result.RESPONSE_STATUS!='Y'){
        this.throwError(result);
        return
      }else{
       //result['CLIENT']='rincon';
        if(result['CLIENT']&&result['CLIENT'].length>0){
          this.curClient=result['CLIENT'];
          this.router.navigate(['/'], { queryParams: { client: result['CLIENT'] } });
         }   
              
        }
        
          this.loginInfo='USER';
          let data={'USER_ID':null};
          //this.userId=null;
          this.cookieService.clearAll();		
          //this.onLogin();
          this.info.emit(data);
          this.getLogo.emit(false);
          if(this.router.url==='/'){
            setTimeout(() => {
            this.openLogin();}, 10); 
          }else{
            //
          if(this.curClient){
             this.router.navigate(['/'], { queryParams: { client: this.curClient} });         
           }else {
              this.router.navigate(['/'])
            }
         }
           
              
            })
  }else{
	  this.loginInfo='USER';
	  let data={'USER_ID':null};
		//this.userId=null;
		this.cookieService.clearAll();		
		//this.onLogin();
		this.info.emit(data);
    this.getLogo.emit(false);
    if(this.router.url==='/'||this.route.snapshot.queryParamMap.get('client')){
        this.openLogin();
      }else{
        this.router.navigate(['/'])
      }
   }   
   // this.openLogin();
   //console.log(this.curClient)
    
    createAuth0Client({
        domain: environment.auth0.domain,
        clientId: environment.auth0.clientId
    }).then(async auth0 => {
        const isAuthenticated = await auth0.isAuthenticated();
        if (isAuthenticated) {
            auth0.logout({
                logoutParams: { returnTo: environment.auth0.redirect_uri } 
            });            
        }        
    });
  }
  logOut(){
    
    Swal.fire({
      title:'LOG OUT?',
      confirmButtonText:'Logout',
      showCloseButton:true,
      showCancelButton:true,
      //focusConfirm:false,
      preConfirm:()=>{
        this.onLogout();
       // this.onLogin();
      }})//.then((result)=>{
        //this.onLogin();
      //})     
      
  }
  updateTemplateTitle(rowData){
		let inputJson={"PROCEDURE":"updatetemplate", "USER_ID":this.userId, "TEMPLATE_ID":rowData.TEMPLATE_ID, "TEMPLATE_TITLE":rowData.TEMPLATE_TITLE};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS=='N'){
        this.throwError(data);
      }
			// for(let i=0; i<this.allTemplates.length;i++){
			// 	if(this.allTemplates[i].TEMPLATE_ID==id){
			// 		this.allTemplates[i]=data;
			// 	}
			// }
		})

	}
  updateCoverpageTitle(rowData){
		let inputJson={"PROCEDURE":"updatecoverpage", "USER_ID":this.userId, "COVERPAGE_ID":rowData.COVERPAGE_ID, "COVERPAGE_TITLE":rowData.TEMPLATE_TITLE};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS=='N'){
        this.throwError(data);
      }
			// for(let i=0; i<this.allTemplates.length;i++){
			// 	if(this.allTemplates[i].TEMPLATE_ID==id){
			// 		this.allTemplates[i]=data;
			// 	}
			// }
		})

	}
  clearForms(){
    this.userData=null;
    this.registrationForm.reset();
  }
  setCredsWarn
  setCredsWarnMessage
 // noPassWordError
  setCreds(){
    if((this.registrationForm.valid && this.registrationForm.value.password == this.registrationForm.value.confirmpassword)||(this.registrationForm.controls.userPhone.valid&&this.userData.USER_SSO_IND == "Y")){
      //if((this.registrationForm.valid && this.registrationForm.value.password == this.registrationForm.value.confirmpassword)||(this.registrationForm.controls.userPhone.valid&&this.userData.USER_SSO_IND == "Y"&&this.registrationForm.controls.singleID.valid)){ 
      let firstname = this.userData.FIRST_NAME //$('#firstname').val();
      let lastname = this.userData.LAST_NAME //$('#lastname').val();;
      let altemail =this.userData.ALTERNATIVE_EMAIL // $('#altemail').val();;
      let jobtitle = this.userData.JOB_TITLE //$('#jobtitle').val();;
      let newpassword = this.registrationForm.value.password //$('#newpassword').val();;
      let phonenumber = this.registrationForm.value.userPhone //$('#phonenumber').val();;
      //let ssoID  = this.registrationForm.value.singleID;
      let company = this.userData.COMPANY_NAME 
      let inputJson={"PROCEDURE":"completeuserregistration","USER_ID":parseInt(this.userData.USER_ID),"ALTERNATIVE_EMAIL":altemail,
      "FIRST_NAME":firstname,"LAST_NAME":lastname, "JOB_TITLE":jobtitle, "PHONE_NUMBER":phonenumber.toString(), "COMPANY_NAME":company};
      if(this.userData.USER_SSO_IND=='N'){
        inputJson["PASSWORD"]=newpassword; 
      }/*else if(this.userData.USER_SSO_IND=='Y'){
        inputJson["SSO_USER_ID"]=ssoID;
      }*/
      console.log(JSON.stringify(inputJson))
      this.reportService.univeralService2(JSON.stringify(inputJson))
      .subscribe(data => {console.log(data)
       if(data.RESPONSE_STATUS == 'N'){
          this.setCredsWarn = true
          this.setCredsWarnMessage = data.MESSAGE;
          this.throwError(data);
          return
        }
        if(data.RESPONSE_STATUS == 'Y'){ 
          this.modalReference3.close();
          this.clearForms();        
          this.openLogin();
        }
      })
    } else {
      //this.noPassWordError = true
    }

    
  }
  modalReference: any;
  userData;
  numberOnly(event): boolean {
    
		const charCode = (event.which) ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
		  return false;
		}
		return true;
	
	  }
  verify(){
    let email = $('#email').val();
    let code = $('#code').val();;
    let inputJson= {"PROCEDURE":"registerrwuser", "USER_EMAIL":email, "INVITATION_CODE":code}
    
    this.reportService.univeralService2(JSON.stringify(inputJson))
    .subscribe(data => {console.log(data)
      if(data.RESPONSE_STATUS=='N'){
        this.throwError(data);
      }else{
      if(data.USER_EMAIL){
        this.userData=data;
        this.registrationForm.patchValue({ userPhone: data["PHONE_NUMBER"] });
        this.modalReference2.close();
        this.open2(this.userinfo);
      }else{
        Swal.fire({
          html: '<p style="font-size:16px; color:red">'+data.MESSAGE+'</p>',//'<p style="font-size:16px; color:red">Login Failed</p>',
          //timer: 3000,
          showConfirmButton:true,
         // timerProgressBar: true,

        })
      }
    }
    })


  }
  reSendCode(){
    let inputJson= {"PROCEDURE":"resendverificationcode","USER_ID":this.tempinfo.USER_ID};
    this.reportService.univeralService(JSON.stringify(inputJson))
    .subscribe(data => {
      if(data.RESPONSE_STATUS=='N'){
        this.throwError(data);
      }else{
          Swal.fire({
           // title:"Hello, "+this.tempinfo.USER_FULL_NAME,
            html: '<p style="font-size:16px; color:green">'+data.MESSAGE+'</p>',
            timer: 2000,
            showConfirmButton:false,
            // timerProgressBar: true,
          })
        }
    })
  }
  mfaverify(){
    let code = $('#mfacode').val();
    let inputJson= {"PROCEDURE":"verifyusermfacode","USER_ID":this.tempinfo.USER_ID,"MFA_CODE":code};
    this.reportService.univeralService(JSON.stringify(inputJson))
    .subscribe(data => {
      if(data.RESPONSE_STATUS=='N'){
        this.throwError(data);
      }else{
        if (this.modalReference5) this.modalReference5.close();
            this.cookieService.setCookieSession("userID",this.tempinfo.USER_ID);
            this.cookieService.setCookieSession("userName",this.tempinfo.USER_FULL_NAME);
            this.cookieService.setCookieSession("r",this.tempinfo.COMPANY_ID+"_"+this.tempinfo.USER_ID);
            this.cookieService.setCookieSession("accepted_disclaimer",this.tempinfo.ACCEPTED_DISCLAIMER);
            this.info.emit(this.tempinfo);
            Swal.fire({
                //title:"Hello, "+this.tempinfo.USER_FULL_NAME,
                html: '<p style="font-size:16px; color:green">'+data.MESSAGE+'</p>',
                timer: 2000,
                showConfirmButton:false,
              // timerProgressBar: true,
              })

            if (this.tempinfo.ACCEPTED_DISCLAIMER == 'N') {
              this.disclaimerAcceptedFlag = false;
              this.disclaimerAcceptedReal = false;
              this.openDisclaimer();
            }
      }
    })


  }
  tempinfo:any;
  onLogin(tokenType: string, tokenValue: string) {
      let username = $('#username').val();
      let password = $('#password').val();;
      if (username === '' || password === '') {
      }
      let resultdata:any;
     
      let inputJson = {"PROCEDURE":"rwuserlogin","USERNAME":username,"PASSWORD":password};
      let loginService: any;
      if ( tokenType == 'JWT' && tokenValue) {
        loginService = this.reportService.ssoLogin(tokenValue);
      }else if(this.ssoclients.findIndex(client=>client.clientid==tokenType)>-1&& tokenValue){
        let index=this.ssoclients.findIndex(client=>client.clientid==tokenType);
        let url=this.ssoclients[index]['Authorize'];
        if(url.length>0){
          loginService = this.reportService.microsoftssoAuthorize(url, tokenValue);       
        }
      }
      /* else if (tokenType == 'stantec' && tokenValue) {
        loginService = this.reportService.samlAuthorize(tokenValue);
      } else if (tokenType == 'stanteccanada' && tokenValue) {
        loginService = this.reportService.stanteccanadasamlAuthorize(tokenValue);
      }else if (tokenType == 'rincon' && tokenValue) {
        loginService = this.reportService.rinconSamlAuthorize(tokenValue);
      }*/ else {
        loginService = this.reportService.univeralService2(JSON.stringify(inputJson));
      }
      loginService.subscribe(data => {
        if(data.RESPONSE_STATUS=='N'){
          this.throwError(data);
          this.openLogin();
        }else{		
        if(data.USER_ID){
          this.loginInfo=data.USER_FULL_NAME;
          this.cookieService.setCookieSession("userInfo",JSON.stringify(data));
          if(data.USER_MFA_IND=='Y'){
            Swal.fire({
              title:"Hello, "+data.USER_FULL_NAME,
              html: '<p style="font-size:16px; color:green">'+data.MFA_EMAIL_MESSAGE+'</p>',
              timer: 1000,
              showConfirmButton:false,
            }).then(() => {
              if (data.WARNING_MESSAGE != "") {
                this.showWarning(data);
              }
            });
            this.tempinfo=data
            this.open4();
          }else{            
            this.cookieService.setCookieSession("userInfo",JSON.stringify(data));
            this.cookieService.setCookieSession("userID",data.USER_ID);
            this.cookieService.setCookieSession("userName",data.USER_FULL_NAME);
            this.cookieService.setCookieSession("r",data.COMPANY_ID+"_"+data.USER_ID);
            this.cookieService.setCookieSession("accepted_disclaimer",data.ACCEPTED_DISCLAIMER);
            this.info.emit(data);
            Swal.fire({
                title:"Hello, "+data.USER_FULL_NAME,
                html: '<p style="font-size:16px; color:green">'+data.MESSAGE+'</p>',
                timer: 2000,
                showConfirmButton:false,
              }).then(() => {
                if (data.WARNING_MESSAGE != "") {
                  this.showWarning(data);
                }
              });

            if (data.ACCEPTED_DISCLAIMER == 'N') {
              this.disclaimerAcceptedFlag = false;
              this.disclaimerAcceptedReal = false;
              this.openDisclaimer();
            }
          }

          
            
          } else{
            Swal.fire({
              html: '<p style="font-size:16px; color:red">'+data.MESSAGE+'</p>',//'<p style="font-size:16px; color:red">Login Failed</p>',
              //timer: 3000,
              showConfirmButton:true,
             // timerProgressBar: true,

            }).then((result)=>{
             // this.onLogin();
             this.openLogin();
            }
            )
          }
        }
          //this.userInfo=data;
        })
        if (this.modalReference) this.modalReference.close();
        return resultdata;//this.userInfo
  }

  /*onAuth0Login() {
    createAuth0Client({
        domain: environment.auth0.domain,
        clientId: environment.auth0.clientId
    }).then(auth0 => {
        auth0.loginWithRedirect({
            authorizationParams: { redirect_uri: environment.auth0.redirect_uri }
        });
    });
  }
*/
//clients=['stantec','stanteccanada', 'rincon'];
generalAzureLogin(){
  this.cookieService.setCookieSession('ssoclient',this.curClient);
  //let index=this.clients.indexOf(this.curClient);
  let index=this.ssoclients.findIndex(client=>client.clientid==this.curClient);
  if(index>-1){
    let url=this.ssoclients[index]['Login'];
    if(url.length>0){
      this.reportService.microsoftssoLogin(url, 'Scriva').subscribe(result => {
        if (result.status == 'Y') {
            (window as any).open(result.data.url, '_self');
        }
      })
    }
  /*switch (index) {
    case 0:
      this.reportService.samlLogin('Scriva').subscribe(result => {
        if (result.status == 'Y') {
            (window as any).open(result.data.url, '_self');
        }
     });
      break;
    
    case 1:
      this.reportService.stanteccanadasamlLogin('Scriva').subscribe(result => {
        if (result.status == 'Y') {
            (window as any).open(result.data.url, '_self');
        }
      });
      break;
    
    case 2:
      this.reportService.rinconSamlLogin('Scriva').subscribe(result => {
        if (result.status == 'Y') {
            (window as any).open(result.data.url, '_self');
        }
      });
    //default:    
  }*/
  }
}
 /*onAzureLogin() {
    this.reportService.samlLogin('Scriva').subscribe(result => {
        if (result.status == 'Y') {
            (window as any).open(result.data.url, '_self');
        }
    });
  }
  oncanadaAzureLogin() {
    this.reportService.stanteccanadasamlLogin('Scriva').subscribe(result => {
        if (result.status == 'Y') {
            (window as any).open(result.data.url, '_self');
        }
    });
  }
	onRinconAzureLogin(){
    this.reportService.rinconSamlLogin('Scriva').subscribe(result => {
      if (result.status == 'Y') {
          (window as any).open(result.data.url, '_self');
      }
  });
  }
  */
  getStatus(id1, id2){
		let inputJson={"PROCEDURE":"getreportstatuslist", "USER_ID":id1, "REPORT_ID":id2}; 
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS=='N'){
        this.throwError(data);
      }else{
			 this.statusList=data.RW_STATUS_LIST ;
      }
			
		})
	}
	
	public changeStatus(status){
		let inputJson={"PROCEDURE":"setreportstatus","USER_ID":this.userId,"REPORT_ID":this.user.REPORT_ID, "STATUS":status};
		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
      if(response.RESPONSE_STATUS=='N'){
        this.throwError(response);
      }	
		})
	}
  // @ViewChild('myFrame') frame: ElementRef;
  // condition = false;
  // winUrl: SafeUrl;

  // public toViewer() {
  //   
  //   this.condition = true;
  //   let url = 'https://www.erisinfo.com/ca/';
  //   this.winUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  // }
	public getRUrl(){
		let inputJson1= {"PROCEDURE":"getreporturl", "USER_ID":this.userId, "REPORT_ID":this.user.REPORT_ID};
		this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(response => {
      if(response.RESPONSE_STATUS=='N'){
        this.throwError(response);
      }else	if(response.RESPONSE_STATUS=='Y'&&response.REPORT_URL&&response.REPORT_URL.length>0){
				window.open(response.REPORT_URL, '_blank');							
			} 
		})
	}

  openSupportPage(){
    let token = JSON.parse(this.cookieService.getCookie("userInfo")).SESSION_ID;
    let support_url = `${environment.support_URL}?t=${token}`; // e.g. http://dev.erisinfo.com/?t=1234.
    window.open(support_url, '_blank');	
  }
  private throwError(data){
		if(data.RESPONSE_STATUS=='N'&&data.ERRORCODE == '9'){
			console.log('Timeout');
      Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
			this.cookieService.clearAll();
			this.router.navigate(['/']);			
		}else{
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
		}
	  }
  
    private showWarning(data){
    Swal.fire({
      html: '<p style="font-size:16px; color:orange;">' + data.WARNING_MESSAGE.replace('\\n', '<br>') + '</p>',
    });
  }
}
